import { MANAGED_KEY } from './constants';

export const MANAGED_DATA = {
  [MANAGED_KEY.club]: {
    id: MANAGED_KEY.club,
    name: 'Передайте управление пользователю',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text text--darken-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [MANAGED_KEY.user]: {
    id: MANAGED_KEY.user,
    name: 'Управляется пользователем',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [MANAGED_KEY.me]: {
    id: MANAGED_KEY.me,
    name: 'Это Вы',
    attrs: {
      color: 'ui-primary',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  MANAGED_DATA,
};
